import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'
import React, { FC } from 'react'

interface DownloadIconProps {
  viewBox?: string
}

const DownloadIcon: FC<SvgIconProps & DownloadIconProps> = props => (
  <SvgIcon viewBox={props.viewBox || '0 0 36 36'} {...props}>
    <path
      opacity="0.4"
      d="M81.9185 33.7446C93.3565 33.7446 102.667 43.2712 102.667 54.98L102.667 78.2544C102.667 89.9346 93.3798 99.4373 81.9652 99.4373L30.0905 99.4373C18.6478 99.4373 9.33316 89.9155 9.33316 78.2067L9.33316 54.9323C9.33316 43.2521 18.6245 33.7446 30.0438 33.7446H34.4305L81.9185 33.7446Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M58.5487 74.173L72.124 60.4464C73.524 59.0277 73.524 56.7446 72.1147 55.3306C70.7053 53.9213 68.4327 53.926 67.0327 55.34L59.5987 62.8563L59.5987 15.1797C59.5987 13.1832 57.9887 11.5625 56.0007 11.5625C54.0173 11.5625 52.412 13.1832 52.412 15.1797L52.412 62.8563L44.9733 55.34C43.5733 53.926 41.3007 53.9213 39.8913 55.3306C39.1867 56.04 38.832 56.9654 38.832 57.8956C38.832 58.8163 39.1867 59.7417 39.882 60.4464L53.4573 74.173C54.134 74.8541 55.0487 75.2393 56.0007 75.2393C56.9573 75.2393 57.872 74.8541 58.5487 74.173Z"
      fill="url(#paint1_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="55.9985"
        y1="32.8062"
        x2="55.9985"
        y2="100.376"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#199C76" />
        <stop offset="1" stop-color="#3F5B9E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="56.002"
        y1="10.6529"
        x2="56.002"
        y2="76.149"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#199C76" />
        <stop offset="1" stop-color="#3F5B9E" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

export default DownloadIcon
